import { useSelector } from 'react-redux';
import { useBreakpoint } from '../hooks/useBreakpoint';
import { selectIsDiscord, selectIsMobile } from '../selectors/app';
import { isLarge } from './breakpoints';
import { useShouldShowPlayer } from './playerStatus/shouldShowPlayer';

// On Web Desktop at or abov the Large breakpoint, the app toast should render in the Player component so that it can
// appear centered above the play button.
export function useShowAppToastInPlayer() {
  const isMobile = useSelector(selectIsMobile);
  const isDiscord = useSelector(selectIsDiscord);
  const isLargeBreakpoint = useBreakpoint(isLarge);
  const shouldShowPlayer = useShouldShowPlayer();

  return !isMobile && !isDiscord && shouldShowPlayer && isLargeBreakpoint;
}
